module.exports = __webpack_public_path__ + "static/media/customer-1.41c0170d.jpg";